export default function (state = {}, action) {
   switch (action.type) {

      case 'GET_EMPLOYEE':
         {
            return {
               ...state,
               employeePayload: action.payload
            };
         }
      default:
         return state;
   }
}
